import { create } from "zustand"

export interface SectionDescriptor {
  id: string
  route: string
  label: string
  type: "home" | "project" | "contact"
  projectId?: string
  imageCount?: number
}

interface SectionScrollState {
  sections: SectionDescriptor[]
  activeSectionIndex: number
  activeImageIndex: number
  wallScrollVelocity: number

  setSections: (sections: SectionDescriptor[]) => void
  setActiveSectionIndex: (i: number) => void
  setActiveImageIndex: (i: number) => void
  setWallScrollVelocity: (v: number) => void
}

export const useSectionScrollStore = create<SectionScrollState>((set) => ({
  sections: [],
  activeSectionIndex: 0,
  activeImageIndex: 0,
  wallScrollVelocity: 0,

  setSections: (sections) => set({ sections }),
  setActiveSectionIndex: (activeSectionIndex) => set({ activeSectionIndex, activeImageIndex: 0 }),
  setActiveImageIndex: (activeImageIndex) => set({ activeImageIndex }),
  setWallScrollVelocity: (wallScrollVelocity) => set({ wallScrollVelocity }),
}))
